// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__-DfF7","link":"HeaderSimple_link__SYRO5","linkSmall":"HeaderSimple_linkSmall__tLGuK","inputSearch":"HeaderSimple_inputSearch__KWLLw"};